import * as actions from './actionsTypes';

const initialData = {
  loader: false,
  dashboardData: {},
  error: ''
}

export default function DashBoardRespBossReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_DASHBOARD_RESPONSIBLE_BOX:
      return {...state, loader: action.payload}
    case actions.GET_DASHBOARD_RESPONSIBLE_BOX:
      return {...state, dashboardData: action.payload}
    case actions.DASHBOARD_ERROR:
      return {...state, error: action.payload}
    default:
      return state
  }
}